module.exports = __webpack_public_path__ + "img/facebook.b6779e2b.svg";